<template>
    <div>
        <div class="header" v-if="!isMobile">
            <div class="header-top">
                <el-image class="header-img" :src="headerImg"></el-image>
            </div>
            <div class="header-content">
                <p class="header-title">{{ headerTitle }}</p>
                <p class="header-desc">{{ headerDesc }}</p>
            </div>
        </div>
        <Nav v-else :headerTitle="headerTitle" :headerDesc="headerDesc" :headerImg="headerImg"></Nav>
    </div>
</template>

<script>
import Nav from './components/nav.vue'
export default {
    name: '',
    props: {
        headerTitle: String,
        headerDesc: String,
        headerImg: String
    },
    data() {
        return {
        };
    },
    computed: {
        isMobile() {
            return this.$store.getters.isMobile;
        }
    },
    components: { Nav },
    watch: {
    },
    methods: {},
};
</script>

<style scoped lang="less">
.header {
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    cursor: default;
    background: @mainBgColor;
    text-align: center;

    .header-top {
        overflow: hidden;

        .header-img {
            width: 100%;
            // height: 600px;
            height: 570px;
            position: relative;

            &:hover {
                cursor: pointer;
                animation-name: scaleImage;
                animation-duration: 0.6s;
                animation-fill-mode: forwards;
                object-fit: cover;
                font-family: 'object-fit:cover;';
            }
        }
    }

    .header-content {
        position: absolute;
        /*  top: 227px;
        left: 370px; */
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;

        .header-title {
            font-size: 50px;
            color: @mainTextColor;
            margin-bottom: 40px;
        }

        .header-desc {
            font-size: 24px;
            color: @mainTextColor;
        }
    }

}


@keyframes scaleImage {
    0% {
        transform: scale(1);
    }

    100% {
        transform: scale(1.1);
    }
}

@media @mobile {
    .header {
        .header-top {
            .header-img {
                height: 424px;
                object-fit: cover;
            }
        }

        .header-content {
            width: 100%;

            .header-title {
                font-size: 24px;
                margin-bottom: 16px;
            }

            .header-desc {
                font-size: 14px;
            }
        }

    }

}
</style>
